// adminAxios.js
import axios from "axios";
import { baseurl } from "../components/config/url";

const adminAxios = axios.create({
  baseURL: baseurl,
  withCredentials: true,
});

const getAnyAdminToken = () => {
  // ✅ priority: adminToken → token → auth.token (optional)
  const adminToken = localStorage.getItem("adminToken");
  const token = localStorage.getItem("token");

  // optional: if you store {token, role} in "auth"
  let authToken = null;
  try {
    const auth = JSON.parse(localStorage.getItem("auth") || "{}");
    authToken = auth?.token || null;
  } catch {}

  return adminToken || token || authToken || "";
};

adminAxios.interceptors.request.use((config) => {
  const t = getAnyAdminToken();
  config.headers = config.headers || {};

  if (t) config.headers.Authorization = `Bearer ${t}`;
  else delete config.headers.Authorization;

  return config;
});

adminAxios.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401) {
      console.log("❌ Admin token invalid/expired");
      // optional cleanup:
      // localStorage.removeItem("adminToken");
      // localStorage.removeItem("token");
    }
    return Promise.reject(err);
  }
);

export default adminAxios;










// import axios from "axios";
// import { baseurl } from "../components/config/url";

// console.log("✅ adminAxios loaded. baseurl =", baseurl);

// const adminAxios = axios.create({
//   baseURL: baseurl,
//   withCredentials: true,
// });

// adminAxios.interceptors.request.use((config) => {
//   const adminToken = localStorage.getItem("adminToken") || "";

//   console.group("➡️ adminAxios request");
//   console.log("URL:", `${baseurl}${config.url}`);
//   console.log("adminToken length:", adminToken.length);

//   if (!adminToken) {
//     console.log("❌ No adminToken in localStorage");
//   } else {
//     config.headers = config.headers || {};
//     config.headers.Authorization = `Bearer ${adminToken}`;
//     console.log("✅ Authorization header set");
//   }

//   console.log("Authorization:", config.headers?.Authorization || "(none)");
//   console.groupEnd();

//   return config;
// });

// export default adminAxios;